document.addEventListener('DOMContentLoaded', function() {
  // Initialize AOS (Animate On Scroll)
  AOS.init({
    duration: 800,
    easing: 'ease-in-out',
    once: false,
    offset: 10,
    // Custom 'once' is left as before. We'll add a global override for translateY...
  });

  // Declare swiper variable
  let sustainableGallerySwiper;

  // Custom control functions
  function updateButtonStates(swiperInstance) {
    const swiper = swiperInstance || sustainableGallerySwiper;
    if (!swiper) return;

    const prevButton = document.querySelector('.sustainable-gallery-prev');
    const nextButton = document.querySelector('.sustainable-gallery-next');
    
    if (!prevButton || !nextButton) return;

    // Get SVG paths for prev button
    const prevPaths = prevButton.querySelectorAll('svg path');
    // Get SVG paths for next button
    const nextPaths = nextButton.querySelectorAll('svg path');

    // Check if we're at the beginning
    if (swiper.isBeginning) {
      prevButton.classList.add('swiper-button-disabled');
      prevButton.setAttribute('aria-disabled', 'true');
      prevButton.setAttribute('tabindex', '-1');
      // Set SVG paths to inactive color
      prevPaths.forEach(path => {
        path.setAttribute('stroke', '#B7B7B7');
      });
    } else {
      prevButton.classList.remove('swiper-button-disabled');
      prevButton.setAttribute('aria-disabled', 'false');
      prevButton.setAttribute('tabindex', '0');
      // Set SVG paths to active color
      prevPaths.forEach(path => {
        path.setAttribute('stroke', '#000000');
      });
    }

    // Check if we're at the end
    if (swiper.isEnd) {
      nextButton.classList.add('swiper-button-disabled');
      nextButton.setAttribute('aria-disabled', 'true');
      nextButton.setAttribute('tabindex', '-1');
      // Set SVG paths to inactive color
      nextPaths.forEach(path => {
        path.setAttribute('stroke', '#B7B7B7');
      });
    } else {
      nextButton.classList.remove('swiper-button-disabled');
      nextButton.setAttribute('aria-disabled', 'false');
      nextButton.setAttribute('tabindex', '0');
      // Set SVG paths to active color
      nextPaths.forEach(path => {
        path.setAttribute('stroke', '#000000');
      });
    }
  }

  // Initialize Sustainable Gallery Swiper
  sustainableGallerySwiper = new Swiper('.sustainable-gallery-swiper', {
    slidesPerView: 1.5,
    spaceBetween: 18,
    loop: true,
    centeredSlides: true,
    speed: 1000,

    breakpoints: {
      // When window width is <= 767px
      0: {
        slidesPerView: 1.1,
        spaceBetween: 8,
      },
      // When window width is >= 768px, default to 1.5
      768: {
        slidesPerView: 1.5,
      },
    },

    on: {
      init: function() {
        updateButtonStates(this);
      },
      slideChange: function() {
        updateButtonStates(this);
      },
    },
  });

  // Custom previous button handler
  const prevButton = document.querySelector('.sustainable-gallery-prev');
  if (prevButton) {
    prevButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      // Check if button is disabled
      if (this.classList.contains('swiper-button-disabled')) {
        return;
      }
      if (!sustainableGallerySwiper.isBeginning) {
        sustainableGallerySwiper.slidePrev();
      }
    });
  }

  // Custom next button handler
  const nextButton = document.querySelector('.sustainable-gallery-next');
  if (nextButton) {
    nextButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      // Check if button is disabled
      if (this.classList.contains('swiper-button-disabled')) {
        return;
      }
      if (!sustainableGallerySwiper.isEnd) {
        sustainableGallerySwiper.slideNext();
      }
    });
  }
});

